import useSWR from 'swr';

import listModels from '../../../../utils/api_functions/listModels';

export const useListModels = () => {
  const {
    data,
    error,
    isLoading,
  } = useSWR(['admin-model-list', null], listModels, {
    refreshInterval: 3000,
    loadingTimeout: 1000,
  });

  return {
    data: data?.models,
    error,
    isLoading,
  }
}

export default useListModels;
